export default {
    messages: {
        "navbar.links.discover": "INFORMACJE O UBISOFT+",
        "navbar.links.store": "Sklep",
        "navbar.links.news": "Newsy",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "Wsparcie",
        "navbar.links.status": "Mój status",
        "navbar.links.featured": "Najciekawsze",
        "navbar.links.rewards": "Odbierz",
        "navbar.links.library": "Wszystkie gry",
        "navbar.links.benefits": "Nagrody UBISOFT+",
        "navbar.links.subscription": "Zarządzanie subskrypcją",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Wszystkie gry",
        "heading.my_games": "Kontynuuj grę",
        "heading.popular_games": "Najpopularniejsze Gry",
        "heading.recommended_games": "Rekomendowane dla ciebie",
        "action.load_more_games": "Wczytaj więcej",
        "action.search_for_game": "Wyszukaj gry",
        "action.launch_game": "Uruchom grę",
        "action.activate_game": "Aktywuj grę",
        "filters.brand": "Filtruj po marce",
        "filters.game_name": "A - Z",
        "filters.release_date": "Data premiery",
        "filters.show_all": "Wyświetl wszystko",
        "filters.sort": "Sortuj wg",
        "filters.all": "Wszystkie",
        "filters.activated": "Aktywowane",
        "message.no_activated_games": "Żadne aktywowane gry nie pasują do twojego wyszukiwania",
        "message.already_owned": "Posiadasz już tę grę",
        "message.no_available_games": "Żadne dostępne gry nie pasują do twojego wyszukiwania",
        "message.no_search_results": "Żadne dostępne gry nie pasują do twojego wyszukiwania",
        "message.error": "Niestety! Podczas przetwarzania twojego żądania wystąpił błąd",
        "message.refresh_page": "Kliknij tutaj, aby ponowić",
        "message.no_subscription": "Nie posiadasz obecnie subskrypcji. Sprawdź szczegóły swojego konta!",
        "warning.savefiles_alert.title": "Ważna informacja dotycząca plików zapisu",
        "warning.savefiles_alert.body": "Rozszerzenie do edycji dostępnej w UBISOFT+ wpłynie na twoje pliki zapisu, w tym na obecne postępy w grze. Jeśli twoja subskrypcja UBISOFT+ się zakończy, aby wczytać dowolny z plików zapisu (w tym obecne postępy w grze), konieczny będzie zakup przepustki sezonowej. Więcej informacji znaleźć można w artykułach znajdujących się {here}.",
        "warning.savefiles_alert.body.here": "tutaj",
        "warning.savefiles_alert.cancel": "Wstecz",
        "warning.savefiles_alert.confirm": "Potwierdź",
        "warning.mobile_launch_alert.body": "Gra {game} została dodana do Twojej biblioteki. Aby zagrać, uruchom Uplay na Twoim PC.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "Warunki subskrypcji",
        "footer.links.privacy_policy_label": "Polityka prywatności",
        "footer.links.legal_label": "Informacje prawne",
        "hero.title": "Usługa subskrypcyjna Ubisoft",
        "hero.subtitle": "Nieograniczony dostęp do ponad 100 gier | Anuluj w dowolnym momencie",
        "hero.buttons.subscribe": "Subskrybuj teraz",
        "hero.buttons.login": "Zaloguj się",
        "hero.buttons.browse": "Wyświetl wszystkie gry",
        "progression.benefits.description": "Odblokuj nasze światy i podbij własne. Chcemy cię wynagrodzić za lojalność! Odbieraj nowe przedmioty do gier co miesiąc.\r\nIm dłużej jesteś w Ubisoft+, tym więcej nagród w grze możesz odebrać!",
        "progression.benefit.singular.reward": "nagroda",
        "progression.benefit.plural.reward": "nagrody",
        "progression.benefit.singular.benefit": "rabat",
        "progression.benefit.plural.benefit": "rabaty",
        "progression.benefit.singular.booster": "premia",
        "progression.benefit.plural.booster": "premie",
        "progression.level.subscribed_for": "Subskrybent UBISOFT+ od",
        "progression.level.new_subscriber": "Nowy subskrybent",
        "progression.level.new_subscribers": "Nowi subskrybenci",
        "progression.level.subscription.first_month": "1 miesiąc",
        "progression.level.subscription.starting_with_months": "Ponad {months} miesiące",
        "general.date.month": "miesiąca",
        "general.date.months": "mies.",
        "general.date.month_remaining": "miesiąc pozostał",
        "general.date.months_remaining": "mies. pozostało",
        "rewards.monthly_rewards": "Twoje comiesięczne nagrody w grze",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} pozostało do odebrania {rewards_left} nagród w tym miesiącu",
        "rewards.current_title": "Nagrody w tym miesiącu",
        "rewards.previous_title": "Twoje poprzednie nagrody",
        "rewards.upcoming_title": "Nadchodzące nagrody",
        "rewards.none_found": "Nie znaleziono nagród",
        "rewards.available": "Dostępne",
        "rewards.locked": "Blokada",
        "rewards.claimed": "Odebrane",
        "rewards.claim": "Tak",
        "rewards.cancel": "Anuluj",
        "rewards.confirm": "Chcesz odebrać tę nagrodę?",
        "rewards.none_left": "Odebrano już wszystkie nagrody za ten miesiąc",
        "rewards.already_claimed": "Odebrano już tę nagrodę",
        "rewards.claim_confirm": "Ta nagroda została przesłana do twojej gry!",
        "rewards.close": "W porządku!",
        "rewards.load_more": "Wczytaj więcej",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};